<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
        <ellipse cx="10" cy="10.6816" rx="7.5" ry="7.5" fill="#70DF7B" />
        <rect x="10" y="7.34839" width="0.00833321" height="0.00833368" stroke="white" stroke-width="1.5"
            stroke-linejoin="round" />
        <path d="M10 10.6817V14.015" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</template>